import { Clickable } from '@shared/Frontend/components/clickable'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { slugify } from '@shared/Frontend/utils/slugify'
import * as React from 'react'
import { InnerHtmlWrapper } from '../../../../../../../EntryPoint/Frontend/legacy/public_site/components/utils/InnerHtmlWrapper'
import { TextBlock } from '../../blocks.state'

export const TextBlockLayout = (props: { id: string } & TextBlock) => {
  const { id, text, intro, label, title, primaryUpdater, secondaryUpdater, showUpdaterAsLink } = props

  const { inView, ref } = useInView({ threshold: 0.1 })
  const hasPrimaryUpdater = primaryUpdater && primaryUpdater.title && primaryUpdater.url
  const hasSecondaryUpdater = secondaryUpdater && secondaryUpdater.title && secondaryUpdater.url
  return (
    <section id={id} ref={ref} className={cn('block block--text ls-block-spacing', inView && 'inview')}>
      <div className="block__inner ls-container">
        <div className="block__layout ls-columns">
          {(label || title || intro) && (
            <header className="block__header ls-columns__header">
              <div className="block__header-inner ls-reversed-column">
                {title && (
                  <h2 id={slugify(title)} className="block__title title--l">
                    {title}
                  </h2>
                )}
                {label && <p className="block__label">{label}</p>}
              </div>
              {intro && <p className="block__intro">{intro}</p>}
            </header>
          )}

          <div className="block__content ls-columns__main-text">
            <InnerHtmlWrapper text={text} className="block__text" />
          </div>

          {(hasPrimaryUpdater || hasSecondaryUpdater) && (
            <footer className="block__footer ls-columns__sidebar">
              <div className="ls-clickables">
                {hasPrimaryUpdater && (
                  <div className="ls-clickable">
                    <Clickable
                      elementKind="link"
                      styleKind={showUpdaterAsLink ? 'link' : 'button'}
                      {...primaryUpdater}
                      className={
                        showUpdaterAsLink
                          ? 'block__clickable block__clickable--secondary link'
                          : 'block__clickable block__clickable--primary link'
                      }
                      onClick={() =>
                        pushDatalayer({
                          category: 'TextBlock',
                          action: primaryUpdater.title
                        })
                      }
                    />
                  </div>
                )}
                {hasSecondaryUpdater && (
                  <div className="ls-clickable">
                    <Clickable
                      elementKind="link"
                      styleKind="link"
                      {...secondaryUpdater}
                      className="block__clickable block__clickable--secondary link"
                      onClick={() =>
                        pushDatalayer({
                          category: 'TextBlock',
                          action: secondaryUpdater.title
                        })
                      }
                    />
                  </div>
                )}
              </div>
            </footer>
          )}
        </div>
      </div>
    </section>
  )
}
